<template>
  <transition name="el-zoom-in-top">
    <div class="content-wrapper dashboard-wrapper" v-loading="loading">
      <!-- Main content -->
      <section class="content">
        <el-row>
          <el-col :span="8">
            <div class="box palette-Pink-300 bg" @click="$router.push({name:'devices'})">
              <div class="box-header   palette-Pink-300 bg">
                <!-- tools box -->
                <div class="pull-right text-white box-tools">
                  <span class="text-white box-btn"><i class="circle-nest-medium ti-car"></i>
                  </span>&nbsp;&nbsp;&nbsp; </div>
                <h3 class="box-title">
                  <span class="text-white">&nbsp;&nbsp;&nbsp;Devices</span>
                </h3>
              </div>
              <!-- /.box-header -->
              <div
                class="box-body no-pad"
                style="display: block;"
              >
                <div class="events-nest ">
                  <div class="wrap-no-pad text-white">
                    <bars
                      :data="[1, 2, 5, 9, 5, 10, 3, 5, 2, 5, 1, 8, 2, 9, 0]"
                      :gradient="['#ffffff', '#ffffff']"
                    ></bars>
                    <h1 class="text-white"><strong>
                        <animate-number
                          v-if="!loading"
                          :from="0"
                          :to="pagination.totalCount"
                          duration="1000"
                          easing="easeOutQuad"
                        ></animate-number>
                      </strong></h1>
                  </div>
                </div>
              </div>
              <!-- /.box-body -->
            </div>
          </el-col>
        </el-row>
      </section>
      <!-- /.content -->
    </div>
  </transition>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'dashboard-first',
  data () {
    return {
      loading: true
    }
  },
  computed: {
    ...mapGetters('devices', ['pagination'])
  },
  methods: {
    ...mapActions('devices', ['fetchDevices'])
  },
  created () {
    this.loading = true
    this.fetchDevices()
      .then(_ => (this.$nextTick(_ => (this.loading = false))))
      .catch(_ => (this.$nextTick(_ => (this.loading = false))))
  }
}
</script>



// WEBPACK FOOTER //
// Index.vue?e53236cc